import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { Outlet, isRouteErrorResponse, useRouteError } from '@remix-run/react';
import { OutlineLinkButton } from '@theprintbar/ui';
import { useEffect } from 'react';

//This just renders the Outlet so everything can render as usual
export default function () {
	return <Outlet />;
}

//We are just here to catch any errors that happen in the child pages so that the header/footer stick around
export function ErrorBoundary() {
	const error = useRouteError();

	useEffect(() => {
		void import('@sentry/remix')
			.then(Sentry => {
				Sentry.captureRemixErrorBoundaryError(error);
			})
			.catch(() => {});
	}, [error]);

	return (
		<div className="flex justify-center mt-8 mb-16">
			{isRouteErrorResponse(error) ? (
				<div className="flex justify-center flex-col items-center">
					<img src={error.status === 404 ? '/images/waiting.gif' : '/images/error.png'} className="w-72 h-72 md:w-96 md:h-96" />
					<h5 className="text-5xl md:text-7xl uppercase font-bold mt-4 md:mt-8">{error.status}</h5>
					<p className="text-lg md:text-2xl mb-4">{error.status === 404 ? "We couldn't find that page" : error.data}</p>
					<OutlineLinkButton icon={ArrowRightIcon} to="/">
						Return Home
					</OutlineLinkButton>
				</div>
			) : (
				<div className="flex justify-center flex-col items-center">
					<img src="/images/error.png" className="w-72 h-72 md:w-96 md:h-96" />
					<h5 className="text-2xl md:text-4xl uppercase font-bold mt-4 md:mt-8">Something went wrong</h5>
					<p className="text-lg mb-4">Please reach out if this problem persists</p>
					<OutlineLinkButton icon={ArrowRightIcon} to="/">
						Return Home
					</OutlineLinkButton>
				</div>
			)}
		</div>
	);
}
